// extracted by mini-css-extract-plugin
export default {"ace-c-log-entry__note-message-content":"log-entry__note-message-content---f3c0161c"};